// BEE-19: How It Works section
import { Heart, Users, Calendar } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

interface Step {
  number: string
  icon: LucideIcon
  title: string
  body: string
}

const STEPS: Step[] = [
  {
    number: '1',
    icon: Heart,
    title: 'Create your canopy',
    body: 'Set up a care hub for your loved one. Add their needs, schedule, and preferences in minutes.',
  },
  {
    number: '2',
    icon: Users,
    title: 'Invite your village',
    body: "Bring in family, friends, and neighbors. Everyone sees what's needed and can pitch in.",
  },
  {
    number: '3',
    icon: Calendar,
    title: 'Coordinate together',
    body: 'Track visits, share updates, claim tasks, and stay in sync — all in one beautiful place.',
  },
]

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-12 sm:py-16 px-6 bg-paper">
      <div className="max-w-[1240px] mx-auto">

        {/* Section header */}
        <div className="text-center mb-8 sm:mb-12">
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-green-700 mb-4">
            How it works
          </p>
          <h2 className="font-serif font-semibold text-[40px] tracking-[-0.02em] text-ink leading-[1.1]">
            Care coordination in three steps
          </h2>
        </div>

        {/* Step cards — 3 col at 900px+, 1 col below */}
        <div className="grid grid-cols-1 min-[900px]:grid-cols-3 gap-6">
          {STEPS.map(({ number, icon: Icon, title, body }) => (
            <div
              key={number}
              className="bg-card border border-[#e8e3d6] rounded-[20px] p-7 shadow-card relative"
            >
              {/* Decorative step number */}
              <span
                className="absolute top-5 right-6 font-serif text-[52px] font-semibold text-[#ece8e0] leading-none select-none"
                aria-hidden="true"
              >
                {number}
              </span>

              {/* Icon tile */}
              <div className="w-10 h-10 rounded-[10px] bg-[#f3f7f3] border border-[#e8efe9] flex items-center justify-center mb-5 text-[#2d5a3d]">
                <Icon size={18} aria-hidden="true" />
              </div>

              <h3 className="font-serif font-semibold text-[20px] text-ink mb-2 leading-snug">
                {title}
              </h3>
              <p className="text-[13.5px] text-[#4a4d47] leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}
